import logger from 'src/utils/logger/logger';
export default function detection (agent) {
  let comp_agent = agent.indexOf("stbkaon") != -1;
  if (comp_agent) {
    logger.info ("[stbkaon detection] detected");
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/stbkaon/detection.js